
import TableList from "@components/templates/tablelist";
import { HttpGetStorageErrorListt,HttpReBilling,HttpNoNeedBilling } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";

import mixin from '../../mixin'

export default {
    mixins: [TableList,mixin],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                    EQ_expenseCategoryType:3,
                    EQ_billingChannel: 'PAYABLE'
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },

    created() {
        this.reSymbal = this.handleAuth("fbb.billing.reBilling");
        this.noneedSymbal = this.handleAuth("fbb.billing.noNeedBilling");
    },

    methods: {
        interceptRequest(params){
            params.search.EQ_expenseCategoryType = 3;
            params.search.EQ_billingChannel = 'PAYABLE';
            if(params.search.EQ_workOrderNo){
                params.search.CN_tradeNo = ('%'+params.search.EQ_workOrderNo)
            }
            delete params.search.EQ_workOrderNo;
            return params
        },
        ajaxRequest: HttpGetStorageErrorListt,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "export":
                    // this.handleWebfs(
                    //     process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billDataProcess/export", this.formData,
                    //     {
                    //         executor: "request",
                    //         download: true,
                    //         method: 'post'
                    //     }
                    // );
                    this.export();
                    break;
                case "revoke":
                    this.operate={
                        show: true,
                        alert: "warning",
                        params:{ids:params, operationObject:'BILLING_DATA'},
                        title: "重新结算",
                        ajaxRequest:HttpReBilling
                    }
                    break;
                case "noneed":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, operationObject:'BILLING_DATA', billingChannel:'PAYABLE'},
                        title: "无需结算",
                        ajaxRequest:HttpNoNeedBilling
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
        export(){
            const {search}=this.formData
            const startAt = search.BT_createdAt ? search.BT_createdAt.slice(0,10) : `''`;
            const endAt = search.BT_createdAt ? search.BT_createdAt.slice(13) : `''`;
            const billingChannel = search.EQ_billingChannel == "PAYABLE" ? 1 : 0;
            const searchItem = {
                context_id: global.SYSID,
                EQ_expenseCategoryType: 3,
                EQ_billingChannel: billingChannel || `''`,
                EQ_organizationId: search.EQ_organizationId || `''`,
                EQ_warehouseId: search.EQ_warehouseId || `''`,
                EQ_lineId: search.EQ_lineId || `''`,
                EQ_tradeNo: search.EQ_tradeNo || `''`,
                EQ_status: search.EQ_status || `''`,
                start_at: startAt,
                end_at: endAt,
                order_no: search.EQ_workOrderNo || `''`,
            }
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                {args:JSON.stringify(searchItem), template_id: 10052, contextId: global.SYSID},
                {
                    executor: "request",
                    download: true,
                    method: "post",
                }
            )
            .then((res) => {
                this.operate = {
                  title: '查询条件导出',
                  show: true,
                  width: 560,
                  component: "comExcel",
                  fileId: res.data.id,
                  showFooter: false
            }})
            .catch((err) => {
                // this.$VMessage.error(err.message);
            });
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "重新结算",
                    operate: "revoke",
                    show:this.reSymbal,
                    more:true,
                    batch:true,
                },
                {
                    name: "无需结算",
                    operate: "noneed",
                    show:this.noneedSymbal,
                    more:true,
                    batch:true,
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.warehouseList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '项目',
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },

                {
                    label: '交易参考号',
                    tag: 'vInput',
                    key: 'EQ_tradeNo',
                },
                {
                    label: '事务单号',
                    tag: 'vInput',
                    key: 'EQ_workOrderNo',
                },
                {
                    label: '结算状态',
                    tag: 'Select',
                    key: 'EQ_status',
                    options:[
                        {label:'未结算',value:0},
                        {label:'结算成功',value:1},
                        {label:'结算失败',value:2},
                        {label:'无需结算',value:4},
                    ]
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },


            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '组织',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId) || '--',
                    // render:(h,{row})=>{
                    //     return <div>{row.organizationName}</div>
                    // }
                },
                {
                    title: '仓库',
                    render: (h, { row }) => this.findRenderLabel(this.warehouseList, row.warehouseId) || '--',
                },
                {
                    title: '项目',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId) || '--',
                },
                {
                    title: '交易参考号',
                    render: (h, { row }) => {
                        return <div>{row.tradeNo || '--'}</div>
                    }
                },
                {
                    title: '事务单号',
                    render: (h, { row }) => {
                        let medata = row.metaData ? JSON.parse(row.metaData) : ''
                        return <div>{medata.workOrderNo || '--'}</div>
                    }
                },
                {
                    title: '结算状态',
                    render: (h, { row }) => {
                        return <div>
                            <Tag type="border" v-show={row.status === 0} color="default">未结算</Tag>
                            <Tag type="border" v-show={row.status === 1} color="success">结算成功</Tag>
                            <Tag type="border" v-show={row.status === 2} color="error">结算失败</Tag>
                            <Tag type="border" v-show={row.status === 4} color="warning">无需结算</Tag>
                        </div>
                    }
                },
                {
                    title: '异常原因',
                    render: (h, { row }) => {
                        return <div>{row.errorMessage || '--'}</div>
                    }
                },

                {
                    title: '创建时间',
                    render: (h, { row }) => {
                        return <div>{row.createdAt || '--'}</div>
                    }
                },
            ];
        },

    },

};
